import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDocumentUpload } from 'Core/hooks';
import CustomPropTypes from 'CustomPropTypes';
import { downloadImage } from 'Core/utils';
import Alert from 'react-bootstrap/Alert';
import { isNotNull } from 'Core/utils';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { FooterButton } from 'Core/components';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import {
  printlabel,
  scrapcatalog,
  printlabelfornotinproduction,
  scanlabel,
  reprintlabel,
  lostlabelreprint,
  printcustomlabels,
  labelquantitysplitter,
} from './store/slice';
import { PRODUCTION_PRINT_ACTIONS } from '../../core/constants/constants';
import { useDispatch } from 'react-redux';
import { Activity, Codesandbox, Divide, Printer } from 'feather-icons-react/build/IconComponents';

const initData = {
  id: 0,
  ProductionResultsId: 0,
  fileName: '',
  filePath: '',
  relativePath: '',
};

const ProductionPrint = ({ data, printers, onAction, onCommentUpdate, key }) => {
  const dispatch = useDispatch();
  const [action, setAction] = useState('');
  const [printer, setPrinter] = useState('');
  const [newQuantity, setNewQuantity] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [customQuantity, setCustomQuantity] = useState('');
  const [numberOfLabels, setNumberOfLabels] = useState('');
  const [error, setError] = useState({
    isError: false,
    fields: '',
  });

  const [toolFilesInputs, setToolFileInputs] = useState(initData);
  const [toolFiles, setToolFiles] = useState(data);
  const updateToolFileField = (field, value) => {
    setToolFileInputs(prevToolFileInputs => ({
      ...prevToolFileInputs,
      [field]: value,
    }));
  };

  const { uploadDocuments, loading } = useDocumentUpload();
  const [isHovering, setIsHovering] = useState(false);

  const handleFileUpload = async event => {
    const files = Array.from(event.target.files);

    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('UploadCategory', 'Production-ProductionPrint');

    const result = await uploadDocuments(formData);
    if (result) {
      const newFile = {
        id: Math.floor(Math.random() * 101),
        fileName: result.fileName,
        filePath: result.filePath,
        relativePath: result.relativePath,
      };
      const newFiles = [...toolFiles, newFile];

      setToolFiles(newFiles);
      setToolFileInputs(initData);
    }
  };

  const downloadImageFn = (e, img) => {
    e.stopPropagation();
    downloadImage(img);
  };

  const removeFile = fileId => {
    const newFiles = toolFiles.filter(toolFile => toolFile.id !== fileId);
    setToolFiles(newFiles);
  };

  const onBtnAction = e => {
    const action = e.target.id;
    setAction(action);
    setNumberOfLabels('');
  };

  const isActionDisabled = actionVal => {
    return action && action != actionVal;
  };

  const selectedPrinterName = () => {
    const selectedPrinter = printers.filter(print => print.printerId == printer);
    return selectedPrinter[0] ? selectedPrinter[0].printerName : '';
  };

  const showPrinters = () => {
    return (
      <>
        <Form.Label htmlFor="printers">Printer</Form.Label>
        <DropdownButton
          className="dropdown-print"
          style={{ width: '100%' }}
          onSelect={setPrinter}
          id="printers"
          title={action ? selectedPrinterName() : 'Select Printer'}
        >
          {printers.map(printer => (
            <Dropdown.Item eventKey={printer.printerId} key={printer.printerId}>
              {printer.printerName}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </>
    );
  };

  const resetActions = () => {
    setAction('');
    setPrinter('');
    setNewQuantity('');
    setCustomQuantity('');
    setSerialNumber('');
    setError({
      isError: false,
      fields: '',
    });
  };

  const checkError = (body, fields) => {
    const errorFields = [];
    let printerField = false;
    Object.keys(body).forEach(key => {
      if (fields.includes(key) && !body[key]) {
        if(key != 'printerId')
          errorFields.push(key);
        else
          printerField = true;
      }
    });
    if (errorFields.length || printerField)
      setError({
        isError: true,
        fields: `${printerField ? 'Please select a Printer. ' : ''}
                  ${errorFields.join(', ')} ${errorFields.length > 1 ? 'are' : 'is'} mandatory`,
      });
    return errorFields.length > 0 || printerField;
  };

  const onActionSubmit = () => {
    switch (action) {
      case PRODUCTION_PRINT_ACTIONS.PRINT_LABEL: {
        const body = {
          partId: data.partId,
          processId: data.id,
          userId: localStorage.getItem('UserId'),
          workTicketNumber: data.workTicketNumber,
          status: data.status,
          numberOfLabels: numberOfLabels,
          printerId: printer,
        };
        if (!checkError(body, ['printerId'])) {
          dispatch(printlabel(body));
          resetActions();
        }
        break;
      }
      case PRODUCTION_PRINT_ACTIONS.PRINT_NOTIN_PRODUCTION: {
        const body = {
          partId: data.partId,
          processId: data.id,
          userId: localStorage.getItem('UserId'),
          workTicketNumber: data.workTicketNumber,
          status: data.status,
          numberOfLabels: numberOfLabels,
          printerId: printer,
        };
        if (!checkError(body, ['printerId'])) {
          dispatch(printlabelfornotinproduction(body));
          resetActions();
        }
        break;
      }
      case PRODUCTION_PRINT_ACTIONS.PRINT_SCRAP_CATALOG: {
        const body = {
          partId: data.partId,
          processId: data.id,
          userId: localStorage.getItem('UserId'),
          workTicketNumber: data.workTicketNumber,
          status: data.status,
          numberOfLabels: 1,
          printerId: printer,
          functionName: 'ScrapCatalog',
        };
        if (!checkError(body, ['printerId'])) {
          dispatch(scrapcatalog(body));
          resetActions();
        }
        break;
      }
      case PRODUCTION_PRINT_ACTIONS.SCAN_LABEL: {
        const body = {
          partId: data.partId,
          serialNumber: serialNumber,
          processId: data.id,
          scannedUserId: localStorage.getItem('UserId'),
          printerId: printer,
        };

        if (!checkError(body, ['serialNumber'])) {
          dispatch(scanlabel(body));
          resetActions();
        }
        break;
      }
      case PRODUCTION_PRINT_ACTIONS.REPRINT_LABEL: {
        const body = {
          partId: data.partId,
          serialNumber: serialNumber,
          processId: data.id,
          scannedUserId: localStorage.getItem('UserId'),
          printerId: printer,
        };
        if (!checkError(body, ['printerId', 'serialNumber'])) {
          dispatch(reprintlabel(body));
          resetActions();
        }
        break;
      }
      case PRODUCTION_PRINT_ACTIONS.LOST_LABEL_REPRINT: {
        const body = {
          partId: data.partId,
          processId: data.id,
          userId: localStorage.getItem('UserId'),
          workTicketNumber: data.workTicketNumber,
          status: data.status,
          numberOfLabels: numberOfLabels,
          printerId: printer,
        };
        if (!checkError(body, ['printerId'])) {
          dispatch(lostlabelreprint(body));
          resetActions();
        }
        break;
      }
      case PRODUCTION_PRINT_ACTIONS.PRINT_CUSTOM_QUANTITY_LABEL: {
        const body = {
          partId: data.partId,
          processId: data.id,
          userId: localStorage.getItem('UserId'),
          workTicketNumber: data.workTicketNumber,
          status: data.status,
          quantity: customQuantity,
          numberOfLabels: numberOfLabels,
          printerId: printer,
        };
        if (!checkError(body, ['printerId', 'quantity'])) {
          dispatch(printcustomlabels(body));
          resetActions();
        }
        break;
      }
      case PRODUCTION_PRINT_ACTIONS.LABEL_QUANTITY_SPLITTER: {
        const body = {
          partId: data.partId,
          processId: data.id,
          userId: localStorage.getItem('UserId'),
          workTicketNumber: data.workTicketNumber,
          status: data.status,
          printerId: printer,
          quantity: newQuantity,
          serialNumber: serialNumber,
        };
        if (!checkError(body, ['serialNumber', 'quantity'])) {
          dispatch(labelquantitysplitter(body));
          resetActions();
        }
        break;
      }
    }
  };

  const showNoOfLabelsFor = [
    PRODUCTION_PRINT_ACTIONS.PRINT_LABEL, 
    PRODUCTION_PRINT_ACTIONS.LOST_LABEL_REPRINT,
    PRODUCTION_PRINT_ACTIONS.PRINT_CUSTOM_QUANTITY_LABEL,
    PRODUCTION_PRINT_ACTIONS.PRINT_NOTIN_PRODUCTION
  ];

  return (
    <>
      <div className=" w-100 d-flex row justify-content-between flex-row">
        <div className="mb-4 col-12 col-lg-4">
          <div className="d-flex flex-column">
            <label className="mb-1">Part Number</label>
            <h5>{isNotNull(data, 'partNumber')}</h5>
          </div>
        </div>
        <div className="mb-4 col-12 col-lg-4">
          <div className="d-flex flex-column">
            <label className="mb-1">Work Ticket</label>
            <h5>{isNotNull(data, 'workTicketNumber')}</h5>
          </div>
        </div>
        <div className="mb-4 col-12 col-lg-4">
          <div className="d-flex flex-column">
            <label className="mb-1">Status</label>
            <h5>{isNotNull(data, 'status')}</h5>
          </div>
        </div>
      </div>
      <div className=" w-100 d-flex row flex-row">
        <div className="mb-4 col-12 col-lg-4">
          <div className="d-flex flex-column">
            <label className="mb-1">Quantity</label>
            <h5>{isNotNull(data, 'quantity')}</h5>
          </div>
        </div>
        <div className="mb-4 col-12 col-lg-4">
          <div className="d-flex flex-column">
            <label className="mb-1">Cell No.</label>
            <h5>{isNotNull(data, 'cellNumber')}</h5>
          </div>
        </div>
      </div>
      <div className="product-action-container w-100 pt-4 d-flex row">
        <div className="print-btns mb-4 px-lg-5 col-12 col-lg-4 d-flex flex-column h-100 justify-content-between">
          <Button
            disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.PRINT_LABEL)}
            variant="warning"
            id="print-label"
            onClick={onBtnAction}
          >
            <Printer size={24} /> Print Label
          </Button>
          <Button
            disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.SCAN_LABEL)}
            variant="secondary"
            id="scan-label"
            onClick={onBtnAction}
          >
            <Codesandbox size={24} /> Scan Label
          </Button>
          <Button
            disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.REPRINT_LABEL)}
            variant="success"
            id="reprint-label"
            onClick={onBtnAction}
          >
            <Printer size={24} /> Reprint Label
          </Button>
          <Button
            disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.LOST_LABEL_REPRINT)}
            variant="warning"
            id="lost-label-reprint"
            onClick={onBtnAction}
          >
            <Printer size={24} /> Lost Label Reprint
          </Button>
          {data.status != 'In Production' && (
            <Button
              disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.PRINT_NOTIN_PRODUCTION)}
              variant="danger"
              id="print-not-in-production"
              onClick={onBtnAction}
            >
              <Printer size={24} /> Print Label for Parts not in production
            </Button>
          )}
          <Button
            disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.PRINT_CUSTOM_QUANTITY_LABEL)}
            variant="success"
            id="print-custom-quantity-label"
            onClick={onBtnAction}
          >
            <Printer size={24} /> Print Custom Quantity Label
          </Button>
          <Button
            disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.LABEL_QUANTITY_SPLITTER)}
            variant="secondary"
            id="label-quantity-splitter"
            onClick={onBtnAction}
          >
            <Divide size={24} />
            Label Quantity Splitter
          </Button>
          <Button
            disabled={isActionDisabled(PRODUCTION_PRINT_ACTIONS.PRINT_SCRAP_CATALOG)}
            variant="danger"
            id="print-scrap-catalog"
            onClick={onBtnAction}
          >
            <Printer size={24} /> Print Scrap Catalog
          </Button>
        </div>
        <div className="mb-4 col-12 col-lg-5 px-lg-5">
          {action ? (
            (function () {
              switch (action) {
                case PRODUCTION_PRINT_ACTIONS.PRINT_CUSTOM_QUANTITY_LABEL:
                  return (
                    <>
                      <div className="d-flex flex-column">
                        <div className="d-flex flex-column mt-3">
                          <Form.Label htmlFor="customQuantity">Custom Quantity</Form.Label>
                          <Form.Control
                            type="text"
                            id="customQuantity"
                            placeholder="Enter Custom Quantity"
                            value={customQuantity}
                            onChange={e => setCustomQuantity(e.target.value)}
                          />
                        </div>
                        <div className="d-flex flex-column mt-3">
                          <Form.Label htmlFor="numberOfLabels">No. of Labels</Form.Label>
                          <Form.Control
                            type="text"
                            id="numberOfLabels"
                            placeholder="No. of Labels"
                            value={numberOfLabels}
                            onChange={e => setNumberOfLabels(e.target.value)}
                          />
                        </div>
                        <div className="d-flex flex-column mt-3">{showPrinters()}</div>
                      </div>
                      <div className="mt-5 d-flex flex-column">
                        <FooterButton
                          cancelText="Cancel"
                          saveBtnClass="ms-3"
                          saveText="Submit"
                          onSave={() => onActionSubmit()}
                          onCancel={() => resetActions()}
                        />
                      </div>
                    </>
                  );
                case PRODUCTION_PRINT_ACTIONS.SCAN_LABEL:
                  return (
                    <>
                      <div className="d-flex flex-column">
                        <div className="d-flex flex-column mt-3">
                          <Form.Label htmlFor="serialNumber">Serial Number</Form.Label>
                          <Form.Control
                            type="text"
                            id="serialNumber"
                            placeholder="Enter Serial Number"
                            value={serialNumber}
                            onChange={e => setSerialNumber(e.target.value)}
                          />
                        </div>
                        {/* <div className="d-flex flex-column mt-3">{showPrinters()}</div> */}
                      </div>
                      <div className="mt-5 d-flex flex-column">
                        <FooterButton
                          cancelText="Cancel"
                          saveBtnClass="ms-3"
                          saveText="Submit"
                          onSave={() => onActionSubmit()}
                          onCancel={() => resetActions()}
                        />
                      </div>
                    </>
                  );
                case PRODUCTION_PRINT_ACTIONS.REPRINT_LABEL:
                  return (
                    <>
                      <div className="d-flex flex-column">
                        <div className="d-flex flex-column mt-3">
                          <Form.Label htmlFor="serialNumber">Serial Number</Form.Label>
                          <Form.Control
                            type="text"
                            id="serialNumber"
                            placeholder="Enter Serial Number"
                            value={serialNumber}
                            onChange={e => setSerialNumber(e.target.value)}
                          />
                        </div>
                        <div className="d-flex flex-column mt-3">{showPrinters()}</div>
                      </div>
                      <div className="mt-5 d-flex flex-column">
                        <FooterButton
                          cancelText="Cancel"
                          saveBtnClass="ms-3"
                          saveText="Submit"
                          onSave={() => onActionSubmit()}
                          onCancel={() => resetActions()}
                        />
                      </div>
                    </>
                  );
                case PRODUCTION_PRINT_ACTIONS.LABEL_QUANTITY_SPLITTER:
                  return (
                    <>
                      <div className="d-flex flex-column">
                        <div className="d-flex flex-column mt-3">
                          <Form.Label htmlFor="serialNumber">Serial Number</Form.Label>
                          <Form.Control
                            type="text"
                            id="serialNumber"
                            placeholder="Enter Serial Number"
                            value={serialNumber}
                            onChange={e => setSerialNumber(e.target.value)}
                          />
                        </div>

                        <div className="d-flex flex-column mt-3">
                          <Form.Label htmlFor="newQuantity">New Quantity</Form.Label>
                          <Form.Control
                            type="text"
                            id="newQuantity"
                            placeholder="Enter New Quantity"
                            value={newQuantity}
                            onChange={e => setNewQuantity(e.target.value)}
                          />
                        </div>
                        <div className="d-flex flex-column mt-3">{showPrinters()}</div>
                      </div>
                      <div className="mt-5 d-flex flex-column">
                        <FooterButton
                          cancelText="Cancel"
                          saveBtnClass="ms-3"
                          saveText="Submit"
                          onSave={() => onActionSubmit()}
                          onCancel={() => resetActions()}
                        />
                      </div>
                    </>
                  );
                default:
                  return action ? (
                    <>
                      <div className="d-flex flex-column mt-3">{showPrinters()}</div>
                      {
                        showNoOfLabelsFor.includes(action) &&
                        <div className="d-flex flex-column mt-3">
                          <Form.Label htmlFor="numberOfLabels">No. of Labels</Form.Label>
                          <Form.Control
                            type="text"
                            id="numberOfLabels"
                            placeholder="No. of Labels"
                            value={numberOfLabels}
                            onChange={e => setNumberOfLabels(e.target.value)}
                          />
                        </div>
                      }
                      <div className="mt-5 d-flex flex-column">
                        <FooterButton
                          cancelText="Cancel"
                          saveBtnClass="ms-3"
                          saveText="Submit"
                          onSave={() => onActionSubmit()}
                          onCancel={() => resetActions()}
                        />
                      </div>
                    </>
                  ) : null;
              }
            })()
          ) : (
            <div className="no-data-container h-100">
              <Alert
                className="h-50px mb-0 w-100 p-3 d-flex justify-content-center align-items-center"
                key={'danger'}
                variant={'danger'}
              >
                <span className="me-3">
                  <Activity size={24} />
                </span>{' '}
                <label>Select any action from the left panel</label>
              </Alert>
            </div>
          )}
          {error && error.isError && <label className="mt-3 text-danger">{error.fields}</label>}
        </div>
      </div>
    </>
  );
};

ProductionPrint.defaultProps = {
  onAction: () => {},
  data: [],
};

ProductionPrint.propTypes = {
  onAction: PropTypes.func,
  data: PropTypes.shape(CustomPropTypes.ProductionResults),
};

export default ProductionPrint;
